import React, { useState,useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import SliderWrapper from 'jd-library/SliderWrapper';
import toastMessageActions from 'jd-library/toastMessageActions';
import useOnScroll from 'jd-library/useOnScroll';
import InputWithMovingLabel from "jd-library/InputWithMovingLabel";
import "./product-synonyms.scss";

const getSourceElements = (sourceIndex = 1) => {
    return {
        name : `S${sourceIndex}`,
        synonymsData : "",
        synonymsErr : "",
    }
}

const AddEditSynonyms = (props) => {
    const[scrollEl,setScrollEl] = useState(null);
    const[scrolled,setScroll] = useState(false);
    const[synonyms,updateSynonyms] = useState([{...getSourceElements(1)}]);

    useOnScroll({
		callback : (e,scrollObj) => {
			if(scrollObj.currScroll.scrollTop){
				setScroll(true);
			}else{
			 	setScroll(false)
			}
		},
		element : !scrollEl ? null : scrollEl,
		deps: [scrollEl]
    })
    
    useEffect(()=>{
        if(props.synonyms && props.synonyms.length){
            let data = [];
            props.synonyms.map((cur,index) => {
                data.push({
                    name : `S${index + 1}`,
                    synonymsData : cur,
                    synonymsErr : "",
                })
            })
            updateSynonyms(data);
        }
    },[])

    const showToast = (errorMsg,type = 'error') => {
        let msg = errorMsg ? errorMsg : 'There is an error'
        let msgData = {message: msg,isMobile : props.isMobile,type : type}
        props.showToastMessage(msgData); 
    }
    
    const addAnotherSynonyms = () => {
        let elements = [...synonyms];
        let pushData = getSourceElements(elements.length + 1);
        elements.push(pushData);
        updateSynonyms(elements);
    }

    const SynonymsValidations = (data) => {
        let isValid = true;
        let errorMsg = '';
        let result = [...data];
        data.map((cur,index) => {
            result[index].synonymsErr = '';
            if(cur.synonymsData){
                let synonym1 = String(cur.synonymsData).trim();
                Object.keys(data).forEach((keys)=>{
                    let key = Number(keys);
                    let synonym2 = String(data[key].synonymsData).trim();
                    if((synonym1.toLowerCase() == synonym2.toLowerCase()) && (key < index)){
                        let msg = 'Synonym Name Cannot be the Same';
                        errorMsg = msg;
                        result[index].synonymsErr = msg;
                        isValid = false;
                    }
                })
            }
        })
        if(isValid){
            return true;
        }else{
            showToast(errorMsg);
            updateSynonyms(result);
            return false;
        }
    }

    const onSynonymsSave = () => {
        let data = [...synonyms];
        if(SynonymsValidations(data)){
            let result = [];
            data.map((cur) => {
                let synonymItem = String(cur.synonymsData).trim();
                if(synonymItem){
                    result.push(synonymItem);
                }
            })
            props.onSaveSynonyms(result);
            window.history.back();
            showToast("Synonyms Updated Successfully",'success');
        }
    }

    let btnProps = [{
        children: 'Save',
        onClick: () => {
            onSynonymsSave()
        }
    }]

    return (
            <SliderWrapper
                header={{
                    heading: props.synonyms && props.synonyms.length ? 'Edit Synonyms' : 'Add Synonyms',
                    variant: 'white',
                    className: 'add-edit-synonyms-header',
                    raised: scrolled
                }}
                footer={{
                    btnProps: btnProps
                }}
                slider = {{
                    className: ('add-edit-synonyms-source' + ' ' + (!props.isMobile ? 'synonyms-web' : 'synonyms-mob'))
                }
                }
                updateScrollContRef={(scrollref) => {
                    setScrollEl(scrollref)
                }}
                onHidden={props.onHidden}
                isMobile = {props.isMobile}
            >
                <div className = {'synonyms-holder'}>
                    <SynonymsInputs
                        synonyms = {synonyms}
                        updateSynonyms = {updateSynonyms}
                        showToast = {showToast}
                        isMobile={props.isMobile}
                    >
                    </SynonymsInputs>
                    {
                      synonyms.length < 300  ? (<div className = {'add-synonyms-holder'} onClick = {() => {
                        addAnotherSynonyms()
                    }}>
                        <span className = {'icon-plus'}></span>
                        Add Another Synonym
                    </div>) : null
                    }
                </div>

            </SliderWrapper>   
    )
}

const SingleSynonymsInput = props => {
    const {
		synonyms,
        updateSynonyms,
        showToast,
        curVal,
        index,
	} = props;
    const inputRef = useRef(null);

    useEffect(() => {
        if(inputRef.current) {
            inputRef.current.scrollIntoView({ behavior: "smooth" });
        }        
    }, []);
	
    const deleteField = indexToRem => {
        let values = [
            ...synonyms
        ];
        if(values.length == 1){
            values[0].synonymsData = "";
            values[0].synonymsErr = "";
        }else{
            values.splice(indexToRem,1);
        }
        updateSynonyms(values);
        showToast("Synonym Deleted");
    }

    const handleSynonymsData = (value,index) =>{
        let values = [
            ...synonyms
        ];
        values[index].synonymsData = value;
        updateSynonyms(values);
        
    }

    let inputSourceUrlProps = {
        value: curVal.synonymsData,
        type: 'text',
        onChange: e => {
            handleSynonymsData(e.target.value,index);
        },
        onFocus: () => {
            let values = [
                ...synonyms
            ];
            values[index].synonymsErr = "";
            updateSynonyms(values);
            if(inputRef.current) {
                let timer = props.isMobile ? 400 : 0;
                setTimeout(() => {
                    inputRef.current.scrollIntoView({ behavior: "smooth" });
                }, timer);
            }
        }
    };

    return (
        <>
            <div className = {`${'synonyms-input-section'}`} ref={inputRef}>
                <InputWithMovingLabel
                    label={'Synonym ' + (index + 1)}
                    holderClass={'synonyms-text'}
                    input={inputSourceUrlProps}
                    key={`S.${index}`}
                    errorMessage = {curVal.synonymsErr}
                    errClass = {((synonyms.length - 1) == index) ? "sysnonyms-error" : ''}
                />
                <div className = {`synonyms-delete-holder ${synonyms.length===1 && index===0 ? "disabled": ""}`} onClick = {
                    () => {
                        deleteField(index);
                    }
                }>
                    <span className = {'icon-trash'} ></span>
                </div>
            </div>
        </>
    )
};

const SynonymsInputs = (props) => {
    const {
		synonyms,
        updateSynonyms,
        showToast,
        isMobile
	} = props;

	const formElements = synonyms.map((curVal,index) => {
        return(
            <SingleSynonymsInput
                synonyms = {synonyms}
                updateSynonyms = {updateSynonyms}
                showToast = {showToast}
                curVal = {curVal}
                index = {index}
                isMobile={isMobile}
            ></SingleSynonymsInput>
        )
	})
	return formElements;

}


const mapStateToProps = state => {
	return {
        isMobile: state.deviceData.isMobile,
	};
};

export default connect(mapStateToProps,{
    showToastMessage: (payload) => {
        return (dispatch) => {
            dispatch(toastMessageActions.showMessage(payload))
        }
    }
    
})(AddEditSynonyms);